import { Entity } from '@api';
import { ScheduleDemoBanner } from '@terminal/views/insight-feed/components/schedule-demo-banner/ScheduleDemoBanner';
import { CatalystWidget } from '@terminal/widgets/catalyst-insights-drawer/catalyst-widget/CatalystWidget';
import { EarningsCatalystController } from '@terminal/widgets/catalyst-insights-drawer/catalyst-widget/EarningsCatalystController';
import { CompanyCatalystWidget } from '@terminal/widgets/catalyst-insights-drawer/company-catalyst-widget/CompanyCatalystWidget';
import { EarningsInsightWidget } from '@terminal/widgets/earnings-insight-drawer/earnings-insight-widget/EarningsInsightWidget';
import { UpgradeToUnlock } from '@terminal/widgets/overview/components/upgrade-to-unlock/UpgradeToUnlock';
import React from 'react';
import { ScenarioInsightWidget } from '../insight-widget/components/insight-drawer/components/insights-drawer-content/ScenarioInsightWidget';
import { ActiveFlow } from './InsightDrawerShell';
import styles from './InsightDrawerShell.module.scss';

export const renderDrawerChildren = ({
  activeFlow,
  insightId,
  isBasicOrLightUser,
  contentWrapperRef,
  expandCitations,
  entity,
  isCatalystGenerationEnabled,
  navigateToKGInsight,
}: {
  activeFlow?: ActiveFlow;
  insightId: string;
  isBasicOrLightUser: boolean;
  contentWrapperRef: React.RefObject<HTMLDivElement | null>;
  expandCitations: boolean;
  entity?: Entity;
  isCatalystGenerationEnabled: boolean;
  navigateToKGInsight: () => void;
}) => {
  if (activeFlow === 'insights' && insightId) {
    return (
      <ScenarioInsightWidget
        insightId={insightId}
        contentWrapperRef={contentWrapperRef}
      />
    );
  }

  if (activeFlow === 'earnings' && !isBasicOrLightUser) {
    return (
      <div
        ref={contentWrapperRef}
        className={
          isCatalystGenerationEnabled ? styles.shellContentWrapper : undefined
        }
      >
        {isCatalystGenerationEnabled ? (
          <EarningsCatalystController
            navigateToKGInsight={navigateToKGInsight}
            expandCitations={expandCitations}
            entity={entity}
          />
        ) : (
          <EarningsInsightWidget
            expandCitations={expandCitations}
            entity={entity}
          />
        )}
      </div>
    );
  }

  if (activeFlow === 'catalyst' && insightId && !isBasicOrLightUser) {
    return (
      <div ref={contentWrapperRef} className={styles.shellContentWrapper}>
        {isCatalystGenerationEnabled ? (
          <CatalystWidget navigateToKGInsight={navigateToKGInsight} />
        ) : (
          <CompanyCatalystWidget
            insightId={insightId}
            expandCitations={expandCitations}
          />
        )}
        <ScheduleDemoBanner />
      </div>
    );
  }

  return <UpgradeToUnlock />;
};
